import { Auth, graphqlOperation } from "aws-amplify";
// import { createUser, updateUser } from '../../graphql/mutations';
import {
  getCustomerProfile,
  getS3SignedURL,
  getProducerUser,
} from "../../graphql/queries";
import { graphql } from "../../utils/api";

const authStore = {
  state: {
    loaded: false,
    error: false,
    cognitoUser: null,
    user: null,
  },
  reducers: {
    SET_ERROR(state, payload) {
      return {
        ...state,
        error: payload,
        loaded: true,
      };
    },
    SET_USER(state, payload) {
      return {
        ...state,
        cognitoUser: payload.cognitoUser,
        profileImage: payload.profileImage || null,
        user: payload.user || null,
        loaded: true,
      };
    },
    SET_ACCOUNT_CREATED(state, payload) {
      return {
        ...state,
        accountCreated: payload,
      };
    },
  },
  effects: (dispatch) => ({
    setUser(payload) {
      dispatch.auth.SET_USER(payload);
    },
    // async onBoardUser(name, rootState) {
    //   const alreadyExistingUser = rootState?.auth?.user;

    //   const cognitoUser = await Auth.currentAuthenticatedUser();
    //   console.log('cognito user ', cognitoUser);
    //   if (!alreadyExistingUser) {
    //     await API.graphql(
    //       graphqlOperation(createUser, {
    //         input: {
    //           userId: cognitoUser.username,
    //           firstName: name,
    //           email: cognitoUser.attributes.email,
    //           userRole: 'M_ADMIN',
    //         },
    //       }),
    //     );
    //   } else {
    //     await API.graphql(
    //       graphqlOperation(updateUser, {
    //         input: {
    //           userId: cognitoUser.username,
    //           firstName: name,
    //         },
    //       }),
    //     );
    //   }
    //   await this.fetchAndSetUser();
    // },
    async fetchAndSetUser() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        // dispatch.auth.SET_COGNITO_USER(user);
        const dbUser = await graphql(
          graphqlOperation(getProducerUser, {
            userId: user.username,
          })
        );
        let s3SignedURL = "";
        console.log(dbUser);
        const finalUser = dbUser?.data?.getProducerUser;

        if (finalUser?.profileImage) {
          await graphql(
            graphqlOperation(getS3SignedURL, {
              contentType: "image/jpeg",
              fileName: finalUser?.profileImage,
              userId: finalUser?.userId,
              requestType: "get",
            })
          ).then((r) => {
            if (r.data?.getS3SignedURL?.signedURL) {
              s3SignedURL = r.data?.getS3SignedURL?.signedURL;
            }
          });
        }

        dispatch.auth.SET_USER({
          user: finalUser,
          profileImage: s3SignedURL,
          cognitoUser: {
            username: user.username,
            attributes: user.attributes,
          },
        });
      } catch (error) {
        console.log("[authReducer]::effects::[fetchAndSetUser]::error", error);
        dispatch.auth.SET_ERROR(true);
      }
    },

    async signup(payload) {
      console.log("payload---->>", payload);
      const {
        email,
        phone_number,
        given_name,
        middle_name,
        family_name,
        firstName,
        middleName,
        lastName,
        addlSignupData,
        addlPaymentDetails,
        username,
        password,
      } = payload;

      const res = await Auth.signUp({
        attributes: {
          email,
          phone_number,
          given_name,
          middle_name,
          family_name,
          "custom:fullName": `${firstName} ${middleName} ${lastName}`,
          // 'custom:lastName': lastName,
          "custom:addlSignupData": addlSignupData,
          "custom:addlPaymentDetails": addlPaymentDetails,
        },
        username,
        password,
      });
      console.log("res is ", res);

      // const user = await Auth.currentAuthenticatedUser();
      // console.log('user is ', user);
      // const mutation = await graphql(
      //   graphqlOperation(createUser, {
      //     userId: res.user.username,
      //     email,
      //   }),
      // );
      return res;
    },
    // updateAuthProcess(payload) {
    //   // dispatch.auth.SET_ACCOUNT_CREATED(payload);
    // },
  }),
};

export default authStore;
